import http from '../../services/http-common';

class UsersInfoService {
    getUserInfoForList(id) {
    return http.get(`/UsersInfo/sp/list/${id}`);
    }
    insert(data) {
        return http.post(`/UsersInfo/db/add`,data);
    }
    update(data) {
        return http.put(`/UsersInfo/db/edit`,data);
    }
    delete(UserID) {
        return http.delete(`/UsersInfo/db/delete/${UserID}`);
    }
}

export default new UsersInfoService();